import { createSlice } from "@reduxjs/toolkit";
import { otherSettingsActionTypes } from "../utils";

const otherSettingsSlice = createSlice({
  name: "otherSettings",

  initialState: {
    ran: null,
    accessCode: null,
    isImgOptional: null,
    defaultImg:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png",
  },

  reducers: {
    updateOtherSettings: (state, action) => {
      const { key, value } = action.payload;

      switch (key) {
        case otherSettingsActionTypes.UPDATE_RAN:
          state.ran = value;
          break;
        case otherSettingsActionTypes.UPDATE_ACCESS_CODE:
          state.accessCode = value;
          break;
        case otherSettingsActionTypes.UPDATE_IS_IMG_OPTIONAL:
          state.isImgOptional = value;
          break;
        case otherSettingsActionTypes.UPDATE_DEFAULT_IMAGE:
          state.defaultImg = value;
          break;
        default:
      }
    },
  },
});

// Export the slice
export { otherSettingsSlice };

// Export the actions
export const { updateOtherSettings } = otherSettingsSlice.actions;

// Export the reducer
export default otherSettingsSlice.reducer;
